import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import EmailIcon from "@material-ui/icons/Email";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import {
  Typography,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Button,
  Tooltip,
} from "@material-ui/core";
import EmailTextFeildMultiple from "containers/New_Einvoice/Utility/EmailTextFeildMultiple";
import { useDispatch, useSelector } from "react-redux";
import { downloadPdfNew, sendMailPdfNew, setSelected, setSelectedRow } from "../action";
import SendIcon from "@material-ui/icons/Send";

const NewPdfModal = ({ openNewPDF, setOpenNewPDF,checkedItems, setCheckedItems }) => {
  const dispatch = useDispatch();
  const {
    selected,
    tableData,
    supplierGstinFilter,
    receipientGstinFilter,
    selectedFromDate,
    selectedToDate,
    totalPages,
    selectedRow,
    totalRecords
  } = useSelector((state) => state.EinvReducerNew);
  const [emails, setEmails] = useState([]);
  const [inputValue, setInputValue] = useState("");
  // const [checkedItems, setCheckedItems] = useState({
  //   eInv: false,
  //   ewayBill: false,
  // });

  const handleCheckboxChange = (event) => {
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked,
    });
  };

  const handleClose = () => {
    setOpenNewPDF(false);
    setEmails([]);
    setInputValue('')
    setCheckedItems({ eInv: false, ewayBill: false });
    dispatch(setSelected([]));
    dispatch(setSelectedRow([]));
    // if(notDownload){
    //   setCheckedItems({ eInv: true, ewayBill: false });
    // }
    // else{
    //   setCheckedItems({ eInv: false, ewayBill: false });
    // }
    
  };

  const handleDownload = async() => {
   await dispatch(
      downloadPdfNew(
        checkedItems,
        selected,
        supplierGstinFilter,
        receipientGstinFilter,
        selectedFromDate,
        selectedToDate,
        totalPages,
        selectedRow
      )
    );
    dispatch(setSelected([]));
    dispatch(setSelectedRow([]));
     setEmails([]);
     setInputValue('')
    setOpenNewPDF(false);
  };

  const handleSendMail = async() => {
    await dispatch(
      sendMailPdfNew(
        emails,
        selected,
        supplierGstinFilter,
        receipientGstinFilter,
        selectedFromDate,
        selectedToDate,
        totalPages,
        selectedRow,
        checkedItems,
        totalRecords
      )
    );
    dispatch(setSelected([]));
    dispatch(setSelectedRow([]));
    setEmails([]);
    setInputValue('')
    setOpenNewPDF(false);
  };

  const notDownload =
    (selected?.length === 0 && tableData?.length > 25) || selected?.length > 25;
    
    const isEmail = inputValue?.length === 0 && checkedItems.eInv === true;

  // useEffect(()=>{
  //   if(notDownload){
  //     setCheckedItems({
  //       eInv: true,
  //     })
  //   }
  // },[])
    
// useEffect(()=>{
//   console.log("selectedRw::",selectedRow)
// },[selectedRow])

  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      fullWidth={true}
      maxWidth="xs"
      open={openNewPDF}
      // PaperProps={{
      //   style: {
      //     width: "35em",
      //     maxWidth: "none",
      //   },
      // }}
      onClose={() => setOpenNewPDF(false)}
    >
      <MuiDialogTitle
        disableTypography
        style={{ color: "#4f2d7f", backgroundColor: "white" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div></div>
          <Typography variant="h6">{"Download/ Email PDF"}</Typography>
          <CloseIcon onClick={handleClose} style={{ cursor: "pointer" }} />
        </div>
      </MuiDialogTitle>
      <MuiDialogContent dividers>
        {/* <div style={{ display: "flex", alignItems: "center", gap: "1.5em" }}>
        <FormControl component="fieldset">
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkedItems.eInv || false}
                  onChange={handleCheckboxChange}
                  name="eInv"
                  color="primary"
                  style={{ color: "#4f2d7f" }}
                />
              }
              label={
                <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Email E-Invoice PDF <EmailIcon fontSize="small" />
                </span>
              }
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={checkedItems.ewayBill || false}
                  onChange={handleCheckboxChange}
                  name="ewayBill"
                  color="primary"
                  style={{ color: "#4f2d7f" }}
                />
              }
              label="EWB PDF"
            />
          </FormGroup>
        </FormControl>
        
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{
                backgroundColor: "#4f2d7f",
                color: "white",
                textTransform: "capitalize",
              }}
            >
              Download
              {selected?.length === 0 || selected?.length > 100 ? (
                <Tooltip
                  title="Download limit exceeded. Please use the Email option to receive the files"
                  arrow
                >
                  <ErrorOutlineIcon
                    fontSize="small"
                    style={{ marginLeft: "0.3em" }}
                  />
                </Tooltip>
              ) : null}
            </Button>
          </div> */}
    <span>
     {selected?.length >= 50 && totalRecords > 50 &&"Note : You can download upto 50 records using download feature. To receive the complete data, please use the 'send to mail' option."}
    </span>
        <div style={{ display: "flex", alignItems: "center",marginTop:'0.5em' }} >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  // checked={
                  //   notDownload ? true : checkedItems.eInv || false
                  // }
                  checked={
                     checkedItems.eInv || false
                  }
                  onChange={handleCheckboxChange}
                  name="eInv"
                  color="primary"
                  style={{ color: "#4f2d7f" }}
                  
                  // disabled={notDownload}
                />
              }
              // label="Email Einv PDF"
              label={
                <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Email PDF <EmailIcon fontSize="small" />
                </span>
              }
              // className="pdf-form-div"
            />

            {/* <div> */}
            <FormControlLabel
            // className="pdf-form-div"
              control={
                <Checkbox
                  checked={checkedItems.ewayBill || false}
                  onChange={handleCheckboxChange}
                  name="ewayBill"
                  color="primary"
                  style={{ color: "#4f2d7f" }}
                />
              }
              // label="EWB PDF"
               label="Include EWB"
            />
            {/* </div> */}
          </div>
        </div>

        {/* {checkedItems?.ewayBill && !checkedItems?.eInv ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{
                backgroundColor: "#4f2d7f",
                color: "white",
                textTransform: "capitalize",
              }}
            >
              Download
              {selected?.length === 0 || selected?.length > 100 ? (
                <Tooltip
                  title="Download limit exceeded. Please use the Email option to receive the files"
                  arrow
                >
                  <ErrorOutlineIcon
                    fontSize="small"
                    style={{ marginLeft: "0.3em" }}
                  />
                </Tooltip>
              ) : null}
            </Button>
          </div>
        ) : checkedItems?.eInv && !checkedItems?.ewayBill ? (
          <EmailTextFeildMultiple emails={emails} setEmails={setEmails} />
        ) : checkedItems?.ewayBill && checkedItems?.eInv ? (
          <EmailTextFeildMultiple emails={emails} setEmails={setEmails} />
        ) : null} */}
        {checkedItems?.eInv && !checkedItems?.ewayBill ? (
          <EmailTextFeildMultiple
            emails={emails}
            setEmails={setEmails}
            handleSendMail={handleSendMail}
            inputValue={inputValue} setInputValue={setInputValue}
          />
        ) : checkedItems?.ewayBill && checkedItems?.eInv ? (
          <EmailTextFeildMultiple
            emails={emails}
            setEmails={setEmails}
            handleSendMail={handleSendMail}
            inputValue={inputValue} 
            setInputValue={setInputValue}
          />
        ) : null}
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',marginTop:'0.5em'}}>
          <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={isEmail ? handleSendMail : null}
                    style={{
                      backgroundColor: isEmail ? "#4f2d7f" : "grey",
                      color: "white",
                      textTransform: "capitalize",
                      // height: "32px",
                     
                      cursor: isEmail ? "pointer" : "not-allowed",
                    }}
                  >
                    Send
                    <SendIcon
                      style={{ height: "15px", width: "15px", marginLeft: "0.2em" }}
                    />
                  </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                // onClick={notDownload ? null : handleDownload}
                onClick={checkedItems.eInv ? null : handleDownload}
                style={{
                  // backgroundColor: notDownload ? "grey" : "#4f2d7f",
                  backgroundColor:  checkedItems.eInv ? 'grey' :"#4f2d7f",
                  color: "white",
                  textTransform: "capitalize",
                  // cursor: notDownload ? "not-allowed" : "pointer",
                  cursor: checkedItems.eInv ? 'not-allowed' : 'pointer',
                  // marginRight:'1.5em'
                  marginLeft: "1em",
                }}
              >
                Download
              </Button>
              {/* {notDownload ? (
                <Tooltip
                  title="Download limit exceeded. Please use the Email option to receive the files"
                  arrow
                >
                  <ErrorOutlineIcon
                    fontSize="small"
                    style={{ marginLeft: "0.3em", cursor: "pointer" }}
                  />
                </Tooltip>
              ) : null} */}
            </div>
      </MuiDialogContent>
    </Dialog>
  );
};

export default NewPdfModal;
